import script from "./EmpNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpNotice.vue?vue&type=script&setup=true&lang=ts"

import "./EmpNotice.vue?vue&type=style&index=0&id=134342de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134342de"]])

export default __exports__